import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { JobCardPage } from '@/features/attendance/pages/JobCardPage';
import { downloadJobCard, jobCardQueryOptions } from '@/features/attendance/api/attendance.api';
import { jobCardSearchSchema } from '@/features/attendance/types/attendance.types';

export const Route = createFileRoute('/_auth/attendance/job-card')({
  validateSearch: jobCardSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Job Card">
      <Suspense fallback={<PageLoader />}>
        <JobCardPage
          queryOptions={jobCardQueryOptions}
          onExport={downloadJobCard}
          title="Job Card Dashboard"
          selfRoute="/attendance/job-card"
          employeeReportRoute="/attendance/employee-report"
        />
      </Suspense>
    </ErrorBoundary>
  ),
});
